export const fakeUser = {
  id: 1,
  firstname: "Mario",
  lastname: "Balotello",
  picture:
    "https://cdn.fastly.picmonkey.com/contentful/h6goo9gw1hh6/2sNZtFAWOdP1lmQ33VwRN3/24e953b920a9cd0ff2e1d587742a2472/1-intro-photo-final.jpg?w=1200&h=992&q=70&fm=webp",
};
